import React from "react";
import { Accordion, Button, Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconCar } from "@tabler/icons-react";
import type { Texts } from "../texts";

type Props = {
    show: boolean;
    loading: boolean;
    error: string | null;
    onBookTransport: () => void;
    onCreateDeparture: () => void;
    t: Texts;
};

export default function TransportSection({
    show,
    loading,
    error,
    onBookTransport,
    onCreateDeparture,
    t,
}: Props) {
    if (!show) return null;

    return (
        <Accordion.Item value="transport">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconCar size={18} />
                    </ThemeIcon>
                }
            >
                {t.transport}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="md">
                    <Stack gap="sm">
                        <Text c="dimmed" size="sm">
                            {t.transportDescription}
                        </Text>

                        {error && (
                            <Paper withBorder p="sm" radius="md">
                                <Text c="red" size="sm">
                                    {error}
                                </Text>
                            </Paper>
                        )}

                        <Group justify="flex-end">
                            <Button
                                color="red"
                                onClick={onBookTransport}
                                loading={loading}
                                variant="light"
                            >
                                {t.createTransport}
                            </Button>
                        </Group>
                    </Stack>

                    <Stack gap="sm">
                        <Text c="dimmed" size="sm">
                            Create a transport booking for Departure
                        </Text>

                        <Group justify="flex-end">
                            <Button
                                color="red"
                                onClick={onCreateDeparture}
                                loading={loading}
                                variant="light"
                            >
                                Create Departure
                            </Button>
                        </Group>
                    </Stack>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}